import { render, staticRenderFns } from "./inicio.vue?vue&type=template&id=bdbcef54&scoped=true"
import script from "./inicio.vue?vue&type=script&lang=js"
export * from "./inicio.vue?vue&type=script&lang=js"
import style0 from "./inicio.vue?vue&type=style&index=0&id=bdbcef54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbcef54",
  null
  
)

export default component.exports